import { render } from "./UpdateDelivery.vue?vue&type=template&id=68964afe"
import script from "./UpdateDelivery.vue?vue&type=script&lang=js"
export * from "./UpdateDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__